<template>
  <div class="order">
    <div class="order-nav">
      <Nav
        :list="navList"
        :activeValue.sync="activeValue"
        @on-success="onNavChange"
        class="channel-nav-container"
      ></Nav>
    </div>
    <div class="order-content">
      <component :is="currentView"></component>
    </div>
  </div>
</template>

<script>
import Nav from "@/components/base/Nav.vue";
import ShopOrder from "./components/ShopOrder.vue";
import HotelOrder from "./components/HotelOrder.vue";
export default {
  name: "order",
  components: { Nav, ShopOrder, HotelOrder },
  data() {
    return {
      navList: [
        {
          label: "购物订单",
          labelEn: "Shopping order",
          value: 1,
        },
        {
          label: "订房订单",
          labelEn: "Room Order",
          value: 2,
        },
      ],
      activeValue: 1,
      currentView: "ShopOrder",
    };
  },
  props: {},
  computed: {},
  async mounted() {
    if (this.$route.query.activeValue == 2) {
      this.activeValue = 2;
      this.currentView = "HotelOrder";
    }
  },
  methods: {
    onNavChange() {
      if (this.activeValue == 1) {
        this.currentView = "ShopOrder";
      } else {
        this.currentView = "HotelOrder";
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.order-nav {
  margin-top: 62px;
}
</style>
